/**
 * Textos de la portada del dashboard de impacto
 */

import type { DashboardFilter, PeriodMetrics } from '@/types/dashboard';
import { formatNumber } from './format';

export const PERIOD_PHRASE: Record<DashboardFilter, string> = {
  yesterday: 'Ayer',
  this_week: 'Esta semana',
  this_month: 'Este mes',
  last_month: 'El mes pasado',
  ytd: 'Este año',
};

export const COMPARISON_LABEL: Record<DashboardFilter, string> = {
  yesterday: 'vs. el día anterior',
  this_week: 'vs. los mismos días de la semana pasada',
  this_month: 'vs. los mismos días del mes pasado',
  last_month: 'vs. el mes anterior',
  ytd: 'vs. el mismo tramo del año pasado',
};

export function plural(count: number, one: string, many: string): string {
  return `${formatNumber(count)} ${count === 1 ? one : many}`;
}

export function impactSentence(filter: DashboardFilter, m: PeriodMetrics): string {
  if (m.memories === 0) return 'Aún no hay recuerdos en este periodo.';

  const seen = m.video_views === 1 ? 'persona ha visto' : 'personas han visto';
  const first = `${PERIOD_PHRASE[filter]}, ${formatNumber(m.video_views)} ${seen} tu restaurante a través de ${plural(m.memories, 'recuerdo', 'recuerdos')}.`;
  const clicked = m.review_clicks === 1 ? 'cliente ha pulsado' : 'clientes han pulsado';
  const back = m.returning_clients === 1 ? 'ha vuelto' : 'han vuelto';
  const second = `${formatNumber(m.review_clicks)} ${clicked} «Dejar reseña» y ${formatNumber(m.returning_clients)} ${back}.`;
  return `${first} ${second}`;
}
